module.exports = __webpack_public_path__ + "img/xxdb.bfbb8fc5.png";